var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.5172C3 12.5172 6.27273 7.01724 12 7.01724C17.7273 7.01724 21 12.5172 21 12.5172C21 12.5172 17.7273 18.0172 12 18.0172C6.27273 18.0172 3 12.5172 3 12.5172Z",
    stroke: "#98A2B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.0172C13.1046 15.0172 14 13.898 14 12.5172C14 11.1365 13.1046 10.0172 12 10.0172C10.8954 10.0172 10 11.1365 10 12.5172C10 13.898 10.8954 15.0172 12 15.0172Z",
    stroke: "#98A2B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiEye);
export default __webpack_public_path__ + "static/media/fi_eye.441a3702142b6072718d5ecb7242c1ba.svg";
export { ForwardRef as ReactComponent };